(function () {
  'use strict';

  var PRODUCT_TYPE_RE = /^product_type:([^\s]+)\s+AND\s+(.+)$/i;
  var LEGACY_SCOPED_RE = /^title:(.+)\s+OR\s+vendor:.+\s+OR\s+tag:.+$/i;

  function isScoped(term) {
    return /^title:/i.test(term) && !/\sOR\s+/i.test(term);
  }

  function scopeSearchTerm(term) {
    term = (term || '').trim().replace(/\s+/g, ' ');
    if (!term || isScoped(term)) return term;

    var legacy = term.match(LEGACY_SCOPED_RE);
    if (legacy) return 'title:' + legacy[1];

    var ptMatch = term.match(PRODUCT_TYPE_RE);
    if (ptMatch) {
      var inner = ptMatch[2].trim();
      if (inner.charAt(0) === '(' && inner.charAt(inner.length - 1) === ')') {
        inner = inner.slice(1, -1).trim();
      }
      var legacyInner = inner.match(LEGACY_SCOPED_RE);
      if (legacyInner) inner = legacyInner[1];
      if (!/^title:/i.test(inner)) inner = 'title:' + inner;
      return 'product_type:' + ptMatch[1] + ' AND ' + inner;
    }

    return 'title:' + term;
  }

  function unscopeSearchTerm(term) {
    term = (term || '').trim();
    if (!term) return '';

    var ptMatch = term.match(PRODUCT_TYPE_RE);
    var inner = ptMatch ? ptMatch[2].trim() : term;

    var legacy = inner.match(LEGACY_SCOPED_RE);
    if (legacy) return legacy[1];

    if (/^title:/i.test(inner)) {
      return inner.replace(/^title:/i, '').trim();
    }

    return inner;
  }

  function getSearchInput(form) {
    return form.querySelector('[data-input-search], .t4s-search-results-bar__input, .t4s-search-form__input, .js_iput_search, [name="q"]');
  }

  function bindForm(form) {
    if (!form || form.getAttribute('data-t4s-search-scope-bound')) return;
    form.setAttribute('data-t4s-search-scope-bound', '1');

    form.addEventListener('submit', function () {
      var input = getSearchInput(form);
      if (!input) return;
      var raw = input.value.trim();
      if (!raw) return;
      input.value = scopeSearchTerm(raw);
    });
  }

  function init() {
    document.querySelectorAll('[data-frm-search], .t4s-search-results-bar__frm, .t4s-search-page-form, .js_frm_search_none').forEach(bindForm);
  }

  window.T4SSearchScope = {
    scopeSearchTerm: scopeSearchTerm,
    unscopeSearchTerm: unscopeSearchTerm
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
